var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import baseStyled, { createGlobalStyle, } from "styled-components";
export var themeFactory = function (config) { return ({
    responsiveBreakpoints: {
        xSmall: 480,
        small: 768,
        medium: 1024,
        large: 1440,
    },
    typography: {
        uiFontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        variants: {
            code: {
                fontSize: "0.9rem",
                fontFamily: "'Inconsolata', 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace",
            },
            slabSmall: {
                fontSize: "0.7rem",
                textTransform: "upperCase",
            },
            slabMedium: {
                fontSize: "0.9rem",
                textTransform: "upperCase",
            },
            slabLarge: {
                fontSize: "1.1rem",
                textTransform: "upperCase",
            },
            h6: {
                fontWeight: "600",
                fontSize: "0.9rem",
            },
            h5: {
                fontWeight: "600",
                fontSize: "1.1rem",
            },
            h4: {
                fontWeight: "500",
                fontSize: "1.3rem",
            },
            h3: {
                fontWeight: "400",
                fontSize: "1.6rem",
            },
        },
    },
    palette: {
        brandColor: config.brandColor,
        dividers: {
            light: "rgba(0,0,0,0.05)",
            medium: "rgba(0,0,0,0.1)",
            dark: "rgba(0,0,0,0.2)",
        },
        text: {
            black: "black",
            dark: "rgba(0,0,0,0.6)",
            medium: "rgba(0,0,0,0.4)",
            light: "rgba(0,0,0,0.2)",
        },
        background: {
            soft: "#fafafa",
        },
        status: {
            success: "#4acc0e",
            error: "#ce330c",
            warning: "#eac807",
        },
    },
    radius: {
        small: "0.2rem",
        medium: "0.4rem",
        large: "0.8rem",
    },
    boxShadows: {
        light: "0 0 1rem rgba(0,0,0,0.05)",
        medium: "0 0 1rem rgba(0,0,0,0.15)",
        dark: "0 0 1rem rgba(0,0,0,0.3)",
    },
    opacities: {
        hover: 0.6,
        disabled: 0.4,
    },
}); };
export var styledWithTheme = baseStyled;
export var globalStyleFactory = function (theme) { return createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    font-family: ", ";\n    background-color: ", ";\n  }\n"], ["\n  body {\n    font-family: ", ";\n    background-color: ", ";\n  }\n"])), theme.typography.uiFontFamily, theme.palette.background.soft); };
var templateObject_1;
//# sourceMappingURL=theme.js.map